
import { FaWhatsapp } from "react-icons/fa";
import { Calendar, ArrowRight } from "lucide-react";
import { openGoogleCalendar } from "@/lib/utils";

export function CTASection() {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="relative bg-brand-secondary rounded-3xl overflow-hidden">
          {/* Background decorativo */}
          <div className="absolute inset-0 opacity-20"
            style={{ backgroundImage: "radial-gradient(circle at 0% 100%, #1F5938 0%, transparent 60%), radial-gradient(circle at 100% 0%, #FFDE59 0%, transparent 50%)" }} />
          <div className="absolute top-6 right-6 w-48 h-48 border border-white/20 rounded-full" />
          <div className="absolute -bottom-8 -left-8 w-32 h-32 border border-white/15 rounded-full" />

          <div className="relative z-10 grid md:grid-cols-2 items-center gap-0">
            {/* Texto */}
            <div className="p-10 md:p-16">
              <p className="text-white/70 font-bold text-xs uppercase tracking-widest font-primary mb-4">
                Sua transformação começa agora
              </p>
              <span className="title-special text-4xl text-white/80 block mb-1">
                Chega de dietas
              </span>
              <h2 className="text-4xl md:text-5xl font-extrabold text-white font-primary leading-tight mb-5">
                que não funcionam.
              </h2>
              <p className="text-white/75 font-primary font-light text-lg leading-relaxed mb-8 max-w-sm">
                Agende sua avaliação gratuita e descubra o plano alimentar feito para o seu corpo e a sua rotina.
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <button
                  onClick={openGoogleCalendar}
                  className="bg-white text-brand-secondary font-extrabold font-primary rounded-full px-8 py-4 text-base flex items-center justify-center gap-2 hover:scale-105 transition-all duration-200 shadow-xl"
                >
                  <Calendar className="w-5 h-5" />
                  Agendar Consulta Gratuita
                </button>
                <a
                  href="https://wa.me/5511998874081"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="border-2 border-white/40 text-white font-bold font-primary rounded-full px-8 py-4 text-base flex items-center justify-center gap-2 hover:bg-white/10 transition-all duration-200"
                >
                  <FaWhatsapp className="w-5 h-5" />
                  WhatsApp
                </a>
              </div>
            </div>

            {/* Lado direito — stats */}
            <div className="hidden md:grid grid-cols-2 gap-px bg-white/10 m-px rounded-r-3xl overflow-hidden">
              {[
                { value: "+500", label: "Pacientes atendidos" },
                { value: "6 anos", label: "De experiência" },
                { value: "3", label: "Consultórios" },
                { value: "5.0 ★", label: "No Google" },
              ].map((stat, i) => (
                <div key={i} className="bg-white/8 hover:bg-white/12 transition-colors p-10 flex flex-col items-center justify-center text-center">
                  <p className="text-4xl font-extrabold text-white font-primary leading-none mb-2">{stat.value}</p>
                  <p className="text-white/50 text-sm font-primary">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Link secundário */}
        <p className="text-center text-gray-400 text-sm font-primary mt-6">
          Tem dúvidas?{" "}
          <a href="/contato" className="text-brand-primary font-bold hover:text-brand-secondary transition-colors inline-flex items-center gap-1">
            Fale com a gente <ArrowRight className="w-3.5 h-3.5" />
          </a>
        </p>
      </div>
    </section>
  );
}
